import React, {useContext, useEffect} from 'react';
import {TitleContext} from '../components/TitleContext';

const Home: React.FC = () => {
  const {setTitle} = useContext(TitleContext);
  useEffect(() => {
    setTitle(
      <div>
        <div className="text-slate-600 text-lg font-medium font-['Inter']  ">
          Home
        </div>
        <div className="text-slate-400 text-sm font-light font-['Inter'] leading-normal ">
          Welcome to the dashboard
        </div>
      </div>,
    );
  }, [setTitle]);
  return <div></div>;
};

export default Home;
